import { keyframes, css } from 'styled-components';

export type AnimationStyle = 'fade' | 'slide' | 'scale' | 'none';

/** Read the current animation preference from the console toggle */
export function getAnimationStyle(): AnimationStyle {
  if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).__UDE_ANIMATION) {
    const val = (window as unknown as Record<string, unknown>).__UDE_ANIMATION;
    if (typeof val === 'string' && ['fade', 'slide', 'scale', 'none'].includes(val)) {
      return val as AnimationStyle;
    }
  }
  return 'slide';
}

// --- Enter keyframes ---

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

// --- Exit keyframes ---

export const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
`;

export const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-20px);
  }
`;

export const scaleOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.7);
  }
`;

const DURATION = '250ms';
const EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

export const ANIMATION_DURATION_MS = 250;

export function getEnterAnimation(style: AnimationStyle) {
  switch (style) {
    case 'fade':
      return css`
        animation: ${fadeIn} ${DURATION} ${EASING} both;
      `;
    case 'slide':
      return css`
        animation: ${slideIn} ${DURATION} ${EASING} both;
      `;
    case 'scale':
      return css`
        animation: ${scaleIn} ${DURATION} ${EASING} both;
      `;
    case 'none':
    default:
      return css``;
  }
}

export function getExitAnimation(style: AnimationStyle) {
  switch (style) {
    case 'fade':
      return css`
        animation: ${fadeOut} ${DURATION} ${EASING} both;
      `;
    case 'slide':
      return css`
        animation: ${slideOut} ${DURATION} ${EASING} both;
      `;
    case 'scale':
      return css`
        animation: ${scaleOut} ${DURATION} ${EASING} both;
      `;
    case 'none':
    default:
      return css``;
  }
}
